interface PaymentSvgProps {
  className?: string;
}

export function DiagnosisPaymentSvg({ className }: PaymentSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="72"
      viewBox="0 0 76 72"
      fill="none"
      className={className}
    >
      <path
        d="M63.2715 50.8796L56.5842 61.7439L54.0273 60.1704L60.7137 49.3052L63.2715 50.8796Z"
        fill="var(--brand-300)"
      />
      <path
        d="M58.7962 39.3218C67.8062 39.322 75.135 46.6508 75.1353 55.6609C75.1353 64.6709 67.8062 71.9998 58.7962 72C49.7861 72 42.4572 64.6713 42.4571 55.6609C42.4572 46.6508 49.7861 39.3218 58.7962 39.3218ZM58.7962 44.2608C52.5114 44.2608 47.3962 49.3761 47.3961 55.6609C47.3962 61.9457 52.5114 67.0601 58.7962 67.0601C65.0808 67.0598 70.1951 61.9457 70.1954 55.6609C70.1953 49.3762 65.0809 44.261 58.7962 44.2608Z"
        fill="var(--brand-300)"
      />
      <path
        d="M12.6931 52.1833C11.0867 54.7498 11.8673 58.1449 14.4338 59.7514L14.6628 59.8939L13.0751 62.4318L12.8461 62.2883C8.88019 59.806 7.67304 54.5603 10.1552 50.5946L12.6931 52.1833Z"
        fill="var(--brand-300)"
      />
      <path
        d="M43.7627 8.90023C47.7284 11.3826 48.9357 16.6283 46.4535 20.594L43.9156 19.0053C45.522 16.4387 44.7405 13.0436 42.174 11.4372L41.9459 11.2947L43.5337 8.75676L43.7627 8.90023Z"
        fill="var(--brand-300)"
      />
      <path
        d="M40.782 0C43.7445 4.10753e-06 46.6434 0.835126 49.1634 2.41248L49.3924 2.555C52.9724 4.79581 55.4689 8.3016 56.4161 12.4178C57.3632 16.5343 56.6494 20.7789 54.4084 24.3595L29.4645 64.2115C26.554 68.8616 21.5325 71.6408 16.0415 71.6408C13.0791 71.6408 10.181 70.8057 7.661 69.2284L7.432 69.0849C3.85195 66.844 1.35545 63.3385 0.408356 59.2221C-0.53865 55.1059 0.174099 50.8618 2.41511 47.2814L27.3589 7.42842C30.2695 2.77847 35.2911 7.04658e-05 40.782 0ZM6.60251 49.9019C5.0595 52.3673 4.56978 55.2809 5.22191 58.1152C5.87409 60.9494 7.58722 63.3564 10.0526 64.8994L10.2816 65.0419C12.0169 66.128 14.0084 66.7018 16.0415 66.7019C19.8249 66.7019 23.2744 64.7928 25.2781 61.5919L36.4388 43.7581L17.7632 32.0692L6.60251 49.9019ZM40.782 4.93993C36.9987 4.94007 33.5499 6.84899 31.5463 10.0499L20.3838 27.8818L39.0603 39.5707L50.2219 21.7389C51.7649 19.2735 52.2547 16.36 51.6025 13.5257C50.9503 10.6914 49.2362 8.28536 46.7709 6.7424L46.5419 6.59892C44.8066 5.51295 42.8149 4.93993 40.782 4.93993Z"
        fill="var(--brand-300)"
      />
    </svg>
  );
}

export function PrescriptionsPaymentSvg({ className }: PaymentSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="63"
      viewBox="0 0 68 63"
      fill="none"
      className={className}
    >
      <path d="M36 40H43V44H36V51H32V44H25V40H32V33H36V40Z" fill="var(--brand-300)" />
      <path d="M55 19H33V15H55V19Z" fill="var(--brand-300)" />
      <path d="M27 12H17V8H27V12Z" fill="var(--brand-300)" />
      <path d="M55 12H33V8H55V12Z" fill="var(--brand-300)" />
      <path
        d="M4 15V0H64V24H68V63H0V15H4ZM5 58.9375H63V28.0625H27V28H22V20H5V58.9375ZM27 24H59V5H9V15H27V24Z"
        fill="var(--brand-300)"
      />
    </svg>
  );
}

export function VideoCallPaymentSvg({ className }: PaymentSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="63"
      viewBox="0 0 70 63"
      fill="none"
      className={className}
    >
      <path
        d="M35.4375 9.625C37.9641 9.625 40.1267 10.528 41.9257 12.3337C43.7251 14.139 44.625 16.3096 44.625 18.845C44.6249 21.3802 43.725 23.5505 41.9257 25.3562C40.1267 27.1615 37.9641 28.0641 35.4375 28.0641C32.9109 28.0641 30.7479 27.1615 28.9485 25.3562C27.1496 23.5506 26.2501 21.3802 26.25 18.845C26.25 16.3096 27.1495 14.139 28.9485 12.3337C30.7479 10.528 32.9109 9.625 35.4375 9.625ZM35.4375 13.5762C33.9938 13.5762 32.7579 14.0921 31.7299 15.1237C30.7017 16.1554 30.1875 17.3962 30.1875 18.845C30.1876 20.2936 30.7018 21.5338 31.7299 22.5654C32.758 23.5971 33.9938 24.1129 35.4375 24.1129C36.8812 24.1129 38.117 23.5971 39.1451 22.5654C40.1732 21.5338 40.6874 20.2936 40.6875 18.845C40.6875 17.3962 40.1733 16.1554 39.1451 15.1237C38.1171 14.0921 36.8812 13.5762 35.4375 13.5762Z"
        fill="var(--brand-300)"
      />
      <path
        d="M70 49.335H40.526V56.6434H47.8951V62.125H22.1049V56.6434H29.474V49.335H0V0H70V49.335ZM5.526 43.8525H15.75V42.2683C15.75 40.9785 16.0994 39.7838 16.7976 38.6846C17.4958 37.5854 18.4285 36.7402 19.5961 36.1493C22.1908 34.873 24.8086 33.9157 27.4489 33.2773C30.0887 32.639 32.7517 32.3195 35.4375 32.3195C38.1229 32.3195 40.7858 32.639 43.4261 33.2773C46.066 33.9157 48.6833 34.873 51.2781 36.1493C52.4458 36.7402 53.3791 37.5852 54.0774 38.6846C54.776 39.7838 55.125 40.9786 55.125 42.2683V43.8525H64.474V5.48157H5.526V43.8525ZM35.4375 36.2715C33.0441 36.2715 30.6723 36.559 28.3221 37.1345C25.9715 37.7105 23.6648 38.5572 21.4033 39.6749C20.875 39.962 20.4573 40.3328 20.1498 40.7866C19.8418 41.241 19.6875 41.735 19.6875 42.2683V43.8525H51.1875V42.2683C51.1875 41.735 51.0332 41.241 50.7252 40.7866C50.4172 40.3328 49.9992 39.962 49.4708 39.6749C47.2094 38.5572 44.9031 37.7105 42.5529 37.1345C40.2023 36.559 37.8305 36.2715 35.4375 36.2715Z"
        fill="var(--brand-300)"
      />
    </svg>
  );
}
